// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1eD65","loaderOuter":"PageOverlayLoader_loaderOuter__1vavQ"};